import {Link} from "react-router-dom";
import LogoDark from "../../images/logo-dark.png";

const EmailConfirm = () => {
    return (
        <div className="wrapper">
            <div className="wrapper-inner">
                <div className="content clearfix">
                    <div className="section-block replicable-content window-height bkg-heavy-rain-gradient">
                        <div className="row flex v-align-middle">
                            <div className="column width-6 offset-3">
                                <div>
                                    <div className="logo mb-50">
                                        <div className="logo-inner center">
                                            <Link to="/"><img src={LogoDark} width="125" alt="흑우촌 로고"/></Link>
                                        </div>
                                    </div>
                                    <div className="signup-box box rounded xlarge bkg-white shadow">
                                        <div className="row">
                                            <div className="column width-12 center">
                                                <h3 className="mb-50">이메일 인증</h3>
                                            </div>
                                            <div className="column width-12">
                                                <blockquote className="icon large center">
                                                    <span className="icon-mail"></span>
                                                    <p>회원가입을 완료하시려면 이메일 인증이 필요합니다. 받은 편지함을 확인해주세요.</p>
                                                </blockquote>
                                            </div>
                                            <p className="mb-20 center">이메일 인증을 완료하셨나요? <Link
                                                to="/login" className="fade-location">로그인</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default EmailConfirm;